var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5885_18603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 13,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0095 2.83919C11.7044 2.52562 11.2097 2.52562 10.9047 2.83919L6.24893 7.62442L1.59321 2.83919C1.28812 2.52562 0.793484 2.52562 0.488398 2.83919C0.183313 3.15276 0.183313 3.66116 0.488398 3.97473L6.24893 9.89551L12.0095 3.97473C12.3146 3.66116 12.3146 3.15276 12.0095 2.83919Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5885_18603)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.000976562,
    width: 12.4995,
    height: 12.4997,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.e880df1ebad02d002cc7f938df2bcfd3.svg";
export { ForwardRef as ReactComponent };